import React from 'react';
import NavigationProvider from "./components/Contexts/NavigationContext"
import FiltersProvider from "./components/Contexts/FiltersContext"
import QueryProvider from "./components/Contexts/QueryContext"
import UserVideoProgressProvider from "./components/Contexts/UserVideoProgressContext"
import ThemeOptionsProvider from './components/Contexts/ThemeOptionsContext';
import ContentSkeleton from "./components/Common/ContentSkeleton"
import { SkeletonTheme } from 'react-loading-skeleton'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useAuth } from "./components/Contexts/AuthContext"
import Header from './components/Header';
import Content from './components/Content';
import Footer from './components/Footer';

import "./stylesheets/fonts/font-awesome-4.7.0/scss/font-awesome.scss";
import "./stylesheets/fonts/league_gothic/stylesheet.css";
import "./stylesheets/style.scss"
import "./App.scss"
import 'react-loading-skeleton/dist/skeleton.css'

const Skeleton = () => (
	<div id="content" className="site-content">
		<div id="primary" className="content-area gold">
			<main id="main" className="site-main">
				<ContentSkeleton spinner={true} />
			</main>
		</div>
	</div>
)

function App() {
	const { nonce } = useAuth();
	return (
			<SkeletonTheme baseColor="#000000" highlightColor="#1a2a2a" enableAnimation={true}>
				<ThemeOptionsProvider>
					<NavigationProvider>
						<div id="page" className="App">
							<GoogleReCaptchaProvider reCaptchaKey={global.config.reCaptchaKey}>
							<QueryProvider>
							<FiltersProvider>
							<UserVideoProgressProvider>
								<Header/>
								{ nonce ? <Content/> : <Skeleton/> }
								<Footer/>
							</UserVideoProgressProvider>
							</FiltersProvider>
							</QueryProvider>
							</GoogleReCaptchaProvider>
						</div>
					</NavigationProvider>
				</ThemeOptionsProvider>
			</SkeletonTheme>
	);
}

export default App;